<template>
    <div class="attachment">
        <div
            class="attachment__icon"
            v-if="!attachment.upload.is_image"
        >
            <i class="fas fa-file attachment__fa" />
        </div>
        <div
            class="attachment__image"
            v-if="attachment.upload.is_image"
        >
            <img
                :src="attachment.upload.full_url"
                :alt="attachment.upload.original_filename"
            >
        </div>
        <div class="attachment__name">
            {{ attachment.upload.name }}
        </div>
        <div class="attachment__actions">
            <a
                :href="attachment.upload.full_url"
                title="Download Attachment"
                download
                target="_blank"
                class="attachment__download"
            ><i class="fa fa-download" /></a>
            <a
                href="#"
                @click.prevent="deleteAttachment"
                title="Delete Attachment"
                class="attachment__delete"
                v-if="!viewOnly"
            ><i class="fa fa-times" /></a>
        </div>
    </div>
</template>

<script>
import Service from '../services/AttachmentsService';
import UploadService from '../services/UploadService';

export default {
    props: {
        attachment: {
            required: true,
            type: Object,
        },
        viewOnly: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        deleteAttachment () {
            if (!window.confirm('Are you sure you want to delete this attachment?')) {
                return;
            }
            if (!this.attachment.id) {
                UploadService.delete(this.attachment.upload.path).then(() => {
                    this.$emit('deleted');
                });
                return;
            }
            Service.delete(this.attachment.id).then(() => {
                this.$emit('deleted');
            });
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/AttachmentComponent.vue